module.exports = "/_next/static/images/IBP-static-sign-in-promo-new-0c5239ab439d4fe4da97ac0614ca6541.png";